module.exports = __webpack_public_path__ + "static/media/street.e361b0cd.svg";